import { FaTrash, FaPen } from "react-icons/fa";

export const UsersRows = [
  {
    id: 1,
    LastName: "Snow",
    FirstName: "Jon",
    Email: "JonSnow@gmail.com",
    Sex: "Female",
    State: "Jos Angeles",
    Country: "JSA",
  },
  {
    id: 2,
    LastName: "Lannister",
    FirstName: "Cersei",
    Email: "AonSnow@gmail.com",

    Sex: "Female",
    State: "Aos Angeles",
    Country: "ASA",
  },
  {
    id: 3,
    LastName: "Lannister",
    FirstName: "Jaime",
    Email: "BonSnow@gmail.com",

    Sex: "Female",
    State: "Bos Angeles",
    Country: "BSA",
  },
  {
    id: 4,
    LastName: "Stark",
    FirstName: "Arya",
    Email: "ConSnow@gmail.com",

    Sex: "Female",
    State: "Cos Angeles",
    Country: "CSA",
  },
  {
    id: 5,
    LastName: "Targaryen",
    FirstName: "Daenerys",
    Email: "DonSnow@gmail.com",

    Sex: "Female",
    State: "Dos Angeles",
    Country: "DSA",
  },
  {
    id: 6,
    LastName: "Melisandre",
    FirstName: "Lidres",
    Email: "EonSnow@gmail.com",

    Sex: "Female",
    State: "Eos Angeles",
    Country: "ESA",
  },
  {
    id: 7,
    LastName: "Clifford",
    FirstName: "Ferrara",
    Email: "FonSnow@gmail.com",

    Sex: "Male",
    State: "Fos Angeles",
    Country: "FSA",
  },
  {
    id: 8,
    LastName: "Frances",
    FirstName: "Rossini",
    Email: "GonSnow@gmail.com",

    Sex: "Male",
    State: "Gos Angeles",
    Country: "GSA",
  },
  {
    id: 9,
    LastName: "Roxie",
    FirstName: "Harvey",
    Email: "HonSnow@gmail.com",

    Sex: "Female",
    State: "Hos Angeles",
    Country: "HSA",
  },
  {
    id: 10,
    LastName: "Snow",
    FirstName: "Jon",
    Email: "IonSnow@gmail.com",

    Sex: "Male",
    State: "Ios Angeles",
    Country: "ISA",
  },
  {
    id: 11,
    LastName: "Lannister",
    FirstName: "Cersei",
    Email: "OonSnow@gmail.com",

    Sex: "Female",
    State: "Oos Angeles",
    Country: "OSA",
  },
  {
    id: 12,
    LastName: "Lannister",
    FirstName: "Jaime",
    Email: "ZonSnow@gmail.com",

    Sex: "Male",
    State: "Zos Angeles",
    Country: "ZSA",
  },
  {
    id: 13,
    LastName: "Stark",
    FirstName: "Arya",
    Email: "JonSnow@gmail.com",

    Sex: "Female",
    State: "Los Angeles",
    Country: "USA",
  },
  {
    id: 14,
    LastName: "Targaryen",
    FirstName: "Daenerys",
    Email: "JonSnow@gmail.com",

    Sex: "Female",
    State: "Los Angeles",
    Country: "USA",
  },
  {
    id: 15,
    LastName: "Melisandre",
    FirstName: "Lidres",
    Email: "JonSnow@gmail.com",

    Sex: "Female",
    State: "Los Angeles",
    Country: "USA",
  },
  {
    id: 16,
    LastName: "Clifford",
    FirstName: "Ferrara",
    Email: "JonSnow@gmail.com",

    Sex: "Female",
    State: "Los Angeles",
    Country: "USA",
  },
  {
    id: 17,
    LastName: "Frances",
    FirstName: "Rossini",
    Email: "JonSnow@gmail.com",

    Sex: "Female",
    State: "Los Angeles",
    Country: "USA",
  },
  {
    id: 18,
    LastName: "Roxie",
    FirstName: "Harvey",
    Email: "JonSnow@gmail.com",

    Sex: "Female",
    State: "Los Angeles",
    Country: "USA",
  },
];
export const ProductRows = [
  {
    id: 1,
    Name: "Iphone X",
    Price: "$233.00",
    Category: "Phones",
    Brand: "Apple",

    Quantity: 28,
  },
  {
    id: 2,
    Name: "Iphone 6",
    Price: "$129.00",
    Category: "Phones",
    Brand: "Apple",
    Quantity: 29,
  },
  {
    id: 3,
    Name: "Lannister",
    Price: "",
    Category: "BonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 20,
  },
  {
    id: 4,
    Name: "Stark",
    Price: "Arya",
    Category: "ConSnow@gmail.com",
    Brand: "Apple",
    Quantity: 23,
  },
  {
    id: 5,
    Name: "Targaryen",
    Price: "Daenerys",
    Category: "DonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 23,
  },
  {
    id: 6,
    Name: "Melisandre",
    Price: "Lidres",
    Category: "EonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 23,
  },
  {
    id: 7,
    Name: "Clifford",
    Price: "Ferrara",
    Category: "FonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 14,
  },
  {
    id: 8,
    Name: "Frances",
    Price: "Rossini",
    Category: "GonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 9,
  },
  {
    id: 9,
    Name: "Roxie",
    Price: "Harvey",
    Category: "HonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 23,
  },
  {
    id: 10,
    Name: "Snow",
    Price: "Jon",
    Category: "IonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 17,
  },
  {
    id: 11,
    Name: "Lannister",
    Price: "Cersei",
    Category: "OonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 23,
  },
  {
    id: 12,
    Name: "Lannister",
    Price: "Jaime",
    Category: "ZonSnow@gmail.com",

    Quantity: 1,
  },
  {
    id: 13,
    Name: "Stark",
    Price: "Arya",
    Category: "JonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 23,
  },
  {
    id: 14,
    Name: "Targaryen",
    Price: "Daenerys",
    Category: "JonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 2,
  },
  {
    id: 15,
    Name: "Melisandre",
    Price: "Lidres",
    Category: "JonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 23,
  },
  {
    id: 16,
    Name: "Clifford",
    Price: "Ferrara",
    Category: "JonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 25,
  },
  {
    id: 17,
    Name: "Frances",
    Price: "Rossini",
    Category: "JonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 9,
  },
  {
    id: 18,
    Name: "Roxie",
    Price: "Harvey",
    Category: "JonSnow@gmail.com",
    Brand: "Apple",
    Quantity: 12,
  },
];

export const UsersColumns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "FirstName", headerName: "First name", width: 130 },
  { field: "LastName", headerName: "Last name", width: 130 },
  {
    field: "Email",
    headerName: "Email",
    width: 200,
  },

  {
    field: "Sex",
    headerName: "Sex",
    width: 100,
  },
  {
    field: "State",
    headerName: "State",
    width: 160,
  },
  {
    field: "Country",
    headerName: "Country",
    width: 120,
  },
  {
    field: "Action",
    headerName: "Action",
    width: 100,
    renderCell: (params) => {
      return (
        <>
          <span>
            <FaPen className="text-blue-400 text-md mx-2 " />
          </span>
          <span>
            <FaTrash className="text-red-400 text-md mx-2 " />
          </span>
        </>
      );
    },
  },
];
